import React, { useState, useCallback, useEffect, useRef } from "react";
import { ThemeProvider } from "@mui/material/styles";
import Suggestions from "../Utils/Suggestions";
import { conditionStatus } from "../initialData/initialData";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import {
  Autocomplete,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  Tooltip,
  Card,
} from "@mui/material";
import dayjs from "dayjs";
import {
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledTextField,
  StyledMultilineTextField,
  StyledButton,
  StyledDatePicker,
  OutlinedIconFab,
  theme,
} from "../StyledComponents";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import Icon from "../Utils/Icons";
import { ChiefComplaintSimplifiedTable } from "./ChiefComplaintSimplifiedTable";

const ChiefComplaintSimplified = React.memo(
  ({
    sectionName,
    activeSection,
    suggestions,
    aiSuggestionToggle,
    ruleSuggestionToggle,
    handleCrossButtonClick,
    data,
    setData,
    startRecording,
    stopRecording,
    isAiEnabled,
  }) => {
    // console.log("Data from Chief Complaints", data);
    const today = dayjs();
    const durationUnits = [
      "minutes",
      "hours",
      "days",
      "weeks",
      "months",
      "years",
    ];
    const [listeningOn, setListeningOn] = useState(false);
    const [newCondition, setNewCondition] = useState({
      condition: "",
      id: null,
      clinical_status_description: "",
      duration: "",
      onset_datetime: "",
      abatement_datetime: null,
      clinical_note: "",
    });
    const [durationInputValue, setDurationInputValue] = useState("");

    const [conditionName, setConditionName] = useState("");
    const [editingIndex, setEditingIndex] = useState(null);
    const [complaints, setComplaints] = useState(data);

    console.log("complaints", complaints);
    console.log("newCondition", newCondition);
    useEffect(() => {
      setComplaints(data);
    }, [data]);

    const handleConditionTyped = (value) => {
      setConditionName(value);
      handleInputChange("condition", { term: value, id: null });
    };
    const handleSuggestionClick = (value) => {
      setConditionName(value);
      handleInputChange("condition", { term: value, id: null });
    };

    console.log("conditionName-->", conditionName);
    const [validationErrors, setValidationErrors] = useState({
      condition: "",
      clinical_status_description: "",
      duration: "",
      onset_datetime: "",
    });

    const validateFields = () => {
      const errors = {};

      if (!newCondition.condition && conditionName.length === 0) {
        errors.condition = "Condition is a mandatory field.";
      }

      if (durationInputValue && !newCondition.duration) {
        errors.duration = "Please select a duration option.";
      }
      // if (!newCondition.onset_datetime) {
      //   errors.onset_datetime = "Start Date is a mandatory field.";
      // }

      setValidationErrors(errors);

      return Object.keys(errors).length === 0; // Return true if no errors
    };
    const calculateOnsetDate = (duration, type) => {
      if (!duration) return null;
      const today = dayjs(); // Current date
      const durationMap = {
        minutes: "minute",
        hours: "hour",
        days: "day",
        weeks: "week",
        months: "month",
        years: "year",
      };
      console.log("date onset", today.subtract(duration, durationMap[type]));
      return today.subtract(duration, durationMap[String(type).toLowerCase()]);
    };
    const getDurationParts = (durationValue) => {
      if (typeof durationValue !== "string" || durationValue.trim() === "") {
        return { duration: "", durationType: "" };
      }
      const parts = durationValue.trim().split(/\s+/);
      const duration = parts[0] || "";
      const durationType = parts.slice(1).join(" ") || "";
      return { duration, durationType };
    };
    // Function to handle adding a new row
    const handleAddCondition = async () => {
      if (!validateFields()) {
        return; // Exit if validation fails
      }

      //   console.log("conditionName in addoption-->", conditionName);
      let newDetails = {
        ...newCondition,
        id: null,
        onset_datetime: newCondition.onset_datetime
          ? dayjs(newCondition.onset_datetime).format("YYYY-MM-DD")
          : null,
        durationType: newCondition.duration
          ? getDurationParts(newCondition.duration).durationType
          : "",
      };

      // console.log("New Condition Added", newCondition);
      // newConditionWithDate = {
      //   ...newCondition,
      //  id:null
      // };
      //   }

      // Add the new condition to the complaints list
      let updatedDetails = [...complaints, newDetails];
      setComplaints(updatedDetails);
      setNewCondition({
        condition: "",
        id: null,
        clinical_status_description: "",
        duration: "",
        onset_datetime: "",
        abatement_datetime: null,
        clinical_note: "",
      });
      setDurationInputValue("");
      setValidationErrors({}); // Clear errors after successful submission
      setConditionName("");
      setData(updatedDetails);
    };

    // Function to handle input changes
    const handleInputChange = (field, value) => {
      let newDetails;
      if (field == "condition") {
        newDetails = {
          ...newCondition,
          [field]: value.term,
          id: value.id,
        };
      } else {
        newDetails = {
          ...newCondition,
          [field]: value,
        };
      }
      console.log("Field and value:", field, value);

      if (field === "clinical_status_description") {
        setValidationErrors((prev) => ({
          ...prev,
          clinical_status_description: "",
        }));
        if (!value) {
          newDetails = {
            ...newDetails,
            abatement_datetime: null,
          };
          const wasResolvedLike =
            newCondition.clinical_status_description === "Resolved" ||
            newCondition.clinical_status_description === "Remission";
          if (wasResolvedLike) {
            newDetails = {
              ...newDetails,
              onset_datetime: null,
            };
          }
        }
      }

      // Validation and additional logic
      if (field === "duration") {
        const numericPart = getDurationParts(value).duration || value;
        const floatValue = parseFloat(numericPart);
        const intValue = parseInt(numericPart, 10);

        if (value && numericPart) {
          if ((floatValue && isNaN(floatValue)) || floatValue <= 0) {
            setValidationErrors((prev) => ({
              ...prev,
              duration: "Duration must be a positive integer",
            }));
          } else if (floatValue && floatValue !== intValue) {
            setValidationErrors((prev) => ({
              ...prev,
              duration: "Duration must be a positive integer",
            }));
          } else {
            setValidationErrors((prev) => ({
              ...prev,
              duration: "",
            }));
          }
        } else {
          setValidationErrors((prev) => ({
            ...prev,
            duration: "",
          }));
        }
      }

      if (field === "duration") {
        const { duration, durationType } = getDurationParts(value);
        const newOnsetDate =
          duration && durationType
            ? calculateOnsetDate(duration, durationType)
            : null;
        newDetails = {
          ...newDetails,
          onset_datetime: newOnsetDate,
        };
      }
      if (field === "onset_datetime") {
        newDetails = {
          ...newDetails,
          duration: "",
        };
        setDurationInputValue("");
      }
      setNewCondition(newDetails);
    };

    // Function to handle row edit
    const handleEditRow = (index) => {
      setConditionName(complaints[index].condition);
      const complaintToEdit = complaints[index];
      const normalizedDuration =
        complaintToEdit.duration && complaintToEdit.durationType
          ? `${complaintToEdit.duration} ${complaintToEdit.durationType}`
          : complaintToEdit.duration || "";
      const { duration } = getDurationParts(normalizedDuration);
      setDurationInputValue(duration);
      setNewCondition({
        ...complaintToEdit,
        duration: normalizedDuration,
      });
      setEditingIndex(index);
    };
    console.log("Editing Index", editingIndex);
    const handleUpdate = async () => {
      if (!validateFields()) {
        return; // Exit if validation fails
      }
      // let newConditionWithDate;

      let newDetails;

      newDetails = {
        ...newCondition,
        source: undefined,
        onset_datetime: newCondition.onset_datetime
          ? dayjs(newCondition.onset_datetime).format("YYYY-MM-DD")
          : null,
        durationType: newCondition.duration
          ? getDurationParts(newCondition.duration).durationType
          : "",
      };

      let updatedDetails = complaints.map((data, i) =>
        i == editingIndex ? newDetails : data
      );
      setComplaints(updatedDetails);
      setEditingIndex(null);
      setNewCondition({
        condition: "",
        id: null,
        clinical_status_description: "",
        duration: "",
        onset_datetime: "",
        abatement_datetime: null,
        clinical_note: "",
      });
      setDurationInputValue("");
      setConditionName("");
      setData(updatedDetails);
    };
    // Function to handle row delete
    const handleDeleteRow = (index) => {
      let updatedDetails = complaints.filter((_, i) => i !== index);
      setComplaints(updatedDetails);
      setData(updatedDetails);
    };

    const memoizedHandleCrossButtonClick = useCallback(
      (sectionName, suggestionName, type) => {
        handleCrossButtonClick(sectionName, suggestionName, type);
      },
      [handleCrossButtonClick]
    );
    const handleClearConditionName = () => {
      setValidationErrors({});
      setConditionName("");

      setNewCondition({
        ...newCondition,
        condition: "", // Use computed property name to set the field dynamically
      });
      setDurationInputValue("");
    };

    return (
      <ThemeProvider theme={theme}>
        {activeSection && (
          <Grid item xs={12}>
            <Suggestions
              sectionName={sectionName}
              suggestions={suggestions}
              activeSection={activeSection}
              aiSuggestionToggle={aiSuggestionToggle}
              ruleSuggestionToggle={ruleSuggestionToggle}
              handleCrossButtonClick={memoizedHandleCrossButtonClick}
              handleSuggestionClick={handleSuggestionClick}
              // handleSuggestionClick={setConditionName}
            />
          </Grid>
        )}

        {activeSection && (
          <Card
            sx={{
              borderRadius: "10px",
              boxShadow: "0 4px 4px 0 #C7C7CC inset",
              backgroundColor: "#FFF",
            }}
          >
            <Grid item xs={12} sm={12} md={12}>
              {/* Input Section */}
              <Grid
                container
                spacing={2}
                sx={{
                  marginTop: "5px",
                  padding: "10px",
                }}
              >
                <Grid item xs={12} sm={9} lg={4}>
                  <StyledTextField
                    value={conditionName}
                    onChange={(e) => {
                      handleConditionTyped(e.target.value);
                    }}
                    InputProps={{
                      endAdornment: (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div style={{ marginRight: "5px" }}>
                            <Tooltip title="Clear">
                              <OutlinedIconFab
                                size="small"
                                variant="contained"
                                onClick={handleClearConditionName}
                              >
                                <Icon name="clearTextField" size={32} />
                              </OutlinedIconFab>
                            </Tooltip>
                          </div>

                          {/* <>
                            {isAiEnabled &&
                              (listeningOn === false ? (
                                <Tooltip title="Start Listening">
                                  <OutlinedIconFab
                                    onClick={() => {
                                      startRecording();
                                      setListeningOn(true);
                                    }}
                                    variant="contained"
                                    color="defaultColor"
                                    size="small"
                                  >
                                    <Icon name="micNotInUse" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                              ) : (
                                <Tooltip title="Stop Listening">
                                  <OutlinedIconFab
                                    onClick={() => {
                                      stopRecording("Chief Complaints");
                                      setListeningOn(false);
                                    }}
                                    variant="outlined"
                                    color="defaultColor"
                                    size="small"
                                  >
                                    <Icon name="micInUse" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                              ))}
                          </> */}
                        </div>
                      ),
                    }}
                    label="Condition Name"
                    fullWidth
                    error={!!validationErrors.condition} // Highlight field in red if there's an error
                    helperText={validationErrors.condition} // Show error message
                  />
                </Grid>
                <Grid item xs={6} sm={9} lg={4}>
                  <Autocomplete
                    options={conditionStatus}
                    value={
                      newCondition.clinical_status_description
                        ? newCondition.clinical_status_description
                        : null
                    }
                    onChange={(_, newValue) =>
                      handleInputChange(
                        "clinical_status_description",
                        newValue ?? ""
                      )
                    }
                    isOptionEqualToValue={(option, value) => option === value}
                    slotProps={{
                      paper: {
                        sx: {
                          "& .MuiAutocomplete-listbox": {
                            fontSize: "12px",
                          },
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <StyledTextField
                        {...params}
                        label="Clinical Status"
                        placeholder="Select clinical status"
                        fullWidth
                        error={!!validationErrors.clinical_status_description}
                        helperText={
                          validationErrors.clinical_status_description || " "
                        }
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Autocomplete
                    freeSolo={false}
                    options={
                      durationInputValue
                        ? durationUnits.map(
                            (unit) => `${durationInputValue} ${unit.toUpperCase()}`
                          )
                        : []
                    }
                    value={newCondition.duration || null}
                    inputValue={newCondition.duration || durationInputValue}
                    open={
                      /^\d+$/.test(durationInputValue) &&
                      !newCondition.duration &&
                      durationInputValue.length > 0
                    }
                    onChange={(_, selectedValue) => {
                      if (!selectedValue) return;
                      const numericPart = selectedValue.split(" ")[0] || "";
                      setDurationInputValue(numericPart);
                      handleInputChange("duration", selectedValue);
                    }}
                    onInputChange={(_, value, reason) => {
                      if (reason === "reset") return;
                      if (value === "") {
                        setDurationInputValue("");
                        handleInputChange("duration", "");
                        return;
                      }
                      const numericPrefixMatch = value.match(/^\d+/);
                      if (numericPrefixMatch) {
                        const numericPart = numericPrefixMatch[0];
                        setDurationInputValue(numericPart);
                        handleInputChange("duration", "");
                        return;
                      }
                      if (/^\d+$/.test(value)) {
                        setDurationInputValue(value);
                        handleInputChange("duration", "");
                      }
                    }}
                    renderInput={(params) => (
                      <StyledTextField
                        {...params}
                        label="Duration"
                        fullWidth
                        error={!!validationErrors.duration}
                        helperText={validationErrors.duration}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={8} sm={9} md={9} lg={8}>
                  <StyledMultilineTextField
                    value={newCondition.clinical_note}
                    onChange={(e) =>
                      handleInputChange("clinical_note", e.target.value)
                    }
                    placeholder="Clinical Notes"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  sm={1}
                  md={1}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <StyledButton
                    bgColor="#0E3F66"
                    onClick={
                      editingIndex != null ? handleUpdate : handleAddCondition
                    }
                    variant="contained"
                    sx={{
                      fontSize: { xs: "0.8rem", sm: "1rem" },
                      width: "100%",
                    }}
                  >
                    {editingIndex != null ? "Update" : "Add"}
                  </StyledButton>
                </Grid>
              </Grid>

              {/* Table Section */}
            </Grid>
          </Card>
        )}
        {complaints && (
          <ChiefComplaintSimplifiedTable
            data={complaints}
            activeSection={activeSection}
            handleEditRow={handleEditRow}
            handleDeleteRow={handleDeleteRow}
          />
        )}
      </ThemeProvider>
    );
  }
);

export default ChiefComplaintSimplified;
